import { render } from "./Alchemy.vue?vue&type=template&id=25b21f28&scoped=true"
import script from "./Alchemy.vue?vue&type=script&lang=js"
export * from "./Alchemy.vue?vue&type=script&lang=js"

import "./Alchemy.vue?vue&type=style&index=0&id=25b21f28&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b21f28"]])

export default __exports__